<template>
  <div class="selectEngineerList">
    <div style="margin-top: 20px">
      <el-form
        ref="ruleForm"
        :model="projectForm"
        label-width="150px"
        :inline="true"
        :rules="rules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="合同清单标题" prop="contractListTitle">
              <el-input v-model="projectForm.contractListTitle"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="施工部位" prop="constructionSite">
              <el-input v-model="projectForm.constructionSite"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属项目">
              <el-input
                v-model="projectForm.projectName"
                :readonly="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="合同编号" prop="serialNumber">
              <el-input
                v-model="projectForm.serialNumber"
                :readonly="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="施工单位">
              <el-input
                v-model="projectForm.partyB"
                :readonly="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="其他">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="projectForm.others"
                maxlength="566"
                size="medium"
                style="width: 100%; min-width: 566px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="projectForm.remarks"
                maxlength="566"
                size="medium"
                style="width: 100%; min-width: 566px"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-bottom: 10px">内部定额表数据：</div>
    <el-table
      ref="multipleTable"
      :data="engineerItems"
      border
      :summary-method="getSummaries"
      show-summary
      fit
    >
      <el-table-column type="index" width="50" label="序号"></el-table-column>
      <el-table-column
        v-for="(item, index) in tableColumnDatas"
        :key="index"
        :prop="item.class"
        :label="item.labelName"
        :sortable="item.sortEnable"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="item.showable">{{
            scope.row[scope.column.property] | numFilter
          }}</span>
          <span v-else-if="item.isNumFilter">{{
            scope.row[scope.column.property] | numFilter
          }}</span>

          <span v-else>{{ scope.row[scope.column.property] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="bottomBtn">
      <el-button type="primary" @click="print">打印预览</el-button>
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
    <sprojectQuotaListPrint
      :visible.sync="printVisible"
      :printData="projectForm"
      :engineerItems="engineerItems"
      v-if="printVisible"
    >
    </sprojectQuotaListPrint>
  </div>
</template>

<script>
import {
  getServiceContractDetailService,
  createOrUpdateSubContractProjectDetailsPrint,
} from "@/services/allContractServices"; //获取一条劳务合同项目信息

import sprojectQuotaListPrint from "./sprojectQuotaListPrint"; //打印工程量清单
import { numFilter } from "@/utils/filters";
export default {
  name: "selectEngineerList",
  props: {
    engineerItems: {
      //内部定额表数据
      type: Array,
      default: () => [],
    },
    contractType: {
      type: String,
      default: "",
    },
    dialogForm: {
      type: Object,
    },
    itemId: {
      type: Number,
      default: null,
    },
  },
  components: {
    sprojectQuotaListPrint,
  },
  data() {
    return {
      printVisible: false,
      tableColumnDatas: [
        { class: "subCategoryNo", labelName: "细目号", sortEnable: false },
        { class: "subCategoryName", labelName: "细目名称", sortEnable: false },
        { class: "unit", labelName: "单位", sortEnable: false },
        { class: "quantity", labelName: "合同数量", sortEnable: false },
        {
          class: "bidPrice",
          labelName: "裸税单价(元)",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "taxRate",
          labelName: "增值税税率(%)",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "synthesizePriceAfterTax",
          labelName: "税后综合单价(元)",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "totalPurePrice",
          labelName: "裸税合价(元)",
          sortEnable: false,
          isNumFilter: false,
        },
        {
          class: "totalPriceAfterTax",
          labelName: "税后合价(元)",
          sortEnable: false,
          isNumFilter: false,
        },
        { class: "remarks", labelName: "备注", sortEnable: false },
      ],
      labeltableColumnDatas: [
        { class: "subCategoryNo", labelName: "细目号", sortEnable: false },
        { class: "subCategoryName", labelName: "细目名称", sortEnable: false },
        // { class: "typeShow", labelName: "类型", sortEnable: false },
        // {
        //   class: "materialCoefficient",
        //   labelName: "材料系数",
        //   sortEnable: false,
        // },
        // { class: "calculateFormula", labelName: "计算公式", sortEnable: false },

        { class: "unit", labelName: "单位", sortEnable: false },
        { class: "quantity", labelName: "合同数量", sortEnable: false },
        {
          class: "materialPrice",
          labelName: "材料单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "totalPrice",
          labelName: "金额",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "guideLaborPrice",
          labelName: "指导劳务单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "bidPrice",
          labelName: "中标裸税单价(元)",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "taxRate",
          labelName: "税率",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "synthesizePriceAfterTax",
          labelName: "税后综合单价(元)",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "totalPurePrice",
          labelName: "裸税合价(元)",
          sortEnable: false,
          isNumFilter: false,
        },
        {
          class: "totalPriceAfterTax",
          labelName: "税后合价(元)",
          sortEnable: false,
          isNumFilter: false,
        },
        { class: "remarks", labelName: "备注", sortEnable: false },
      ],
      othertableColumnDatas: [
        { class: "subCategoryNo", labelName: "细目号", sortEnable: false },
        { class: "subCategoryName", labelName: "细目名称", sortEnable: false },
        // { class: "typeShow", labelName: "类型", sortEnable: false },
        // {
        //   class: "materialCoefficient",
        //   labelName: "材料系数",
        //   sortEnable: false,
        // },
        // { class: "calculateFormula", labelName: "计算公式", sortEnable: false },

        { class: "unit", labelName: "单位", sortEnable: false },
        { class: "quantity", labelName: "合同数量", sortEnable: false },
        // {
        //   class: "materialPrice",
        //   labelName: "材料单价",
        //   sortEnable: false,
        //   isNumFilter: true,
        // },
        // {
        //   class: "totalPrice",
        //   labelName: "金额",
        //   sortEnable: false,
        //   isNumFilter: true,
        // },
        {
          class: "bidPrice",
          labelName: "裸税单价(元)",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "taxRate",
          labelName: "增值税税率(%)",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "totalPurePrice",
          labelName: "裸税合价(元)",
          sortEnable: false,
          isNumFilter: false,
        },
        {
          class: "totalPriceAfterTax",
          labelName: "税后合价(元)",
          sortEnable: false,
          isNumFilter: false,
        },
        { class: "remarks", labelName: "备注", sortEnable: false },
      ],
      //物资清单列
      goodColumnDatas: [
        { class: "productNumber", labelName: "存货编码", sortEnable: false },
        { class: "productName", labelName: "存货名称", sortEnable: false },
        //  { class: "材料", labelName: "类型", sortEnable: false },
        { class: "model", labelName: "规格型号", sortEnable: false },
        { class: "factoryName", labelName: "厂商", sortEnable: false },
        { class: "unit", labelName: "计量单位", sortEnable: false },
        { class: "quantity", labelName: "数量", sortEnable: false },
        {
          class: "unitPrice",
          labelName: "单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "taxRate",
          labelName: "税率",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "bidPrice",
          labelName: "中标裸税单价",
          sortEnable: false,
          isNumFilter: true,
        },
        {
          class: "totalPurePrice",
          labelName: "裸税合价",
          sortEnable: false,
          isNumFilter: false,
        },
        {
          class: "totalPrice",
          labelName: "金额",
          sortEnable: false,
          isNumFilter: true,
        },
        { class: "remarks", labelName: "备注", sortEnable: false },
      ],
      projectForm: {
        subContractId: this.dialogForm.id,
        serialNumber: this.dialogForm.serialNumber, // 合同编号
        projectName: this.dialogForm.projectName, //项目名称
        partyB: this.dialogForm.partyB, // 施工单位
        constructionSite:
          this.dialogForm.subContractProjectDetailsPrintVO?.constructionSite ??
          "", //施工部位
        contractListTitle:
          this.dialogForm.subContractProjectDetailsPrintVO?.contractListTitle ??
          "", //合同清单标题
        others: this.dialogForm.subContractProjectDetailsPrintVO?.others ?? "", //其他
        remarks:
          this.dialogForm.subContractProjectDetailsPrintVO?.remarks ?? "", //备注
      },

      rules: {
        contractListTitle: [
          { required: true, message: "请填写合同清单标题", trigger: "blur" },
          {
            min: 3,
            max: 30,
            message: "长度在 3 到 30 个字符",
            trigger: "blur",
          },
        ],
        constructionSite: [
          { required: true, message: "请填写施工部位", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    if (this.contractType === "LABOR") {
      this.tableColumnDatas = this.labeltableColumnDatas;
    } else {
      this.tableColumnDatas = this.othertableColumnDatas;
    }
  },
  watch: {
    "dialogForm.id": {
      handler(newName, oldName) {
        if (this.contractType === "LABOR") {
          this.tableColumnDatas = this.labeltableColumnDatas;
        } else {
          this.tableColumnDatas = this.othertableColumnDatas;
        }
        this.projectForm = {
          subContractId: this.dialogForm.id,
          serialNumber: this.dialogForm.serialNumber, // 合同编号
          projectName: this.dialogForm.projectName, //项目名称
          partyB: this.dialogForm.partyB, // 施工单位
          constructionSite:
            this.dialogForm.subContractProjectDetailsPrintVO
              ?.constructionSite ?? "", //施工部位
          contractListTitle:
            this.dialogForm.subContractProjectDetailsPrintVO
              ?.contractListTitle ?? "", //合同清单标题
          others:
            this.dialogForm.subContractProjectDetailsPrintVO?.others ?? "", //其他
          remarks:
            this.dialogForm.subContractProjectDetailsPrintVO?.remarks ?? "", //备注
        };
      },
    },
  },
  methods: {
    //保存工程量清单
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (!valid) return;
        console.log("formDate___", this.projectForm);
        createOrUpdateSubContractProjectDetailsPrint({
          ...this.projectForm,
          subContractId: this.dialogForm.id,
        })
          .then((res) => {
            if (res.code == 10000000) {
              this.$alert("保存成功", "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert(res.msg, "确定");
            }
          })
          .catch((err) => {
            this.$message.error("网络请求失败");
          });
      });
    },
    print() {
      this.$refs["ruleForm"].validate((valid) => {
        if (!valid) return;
        this.printVisible = true;
        this.$emit("handlePrint", {
          formData: this.formData,
          approveList: this.approveList,
        });
      });
    },
    getSummaries(param) {
      let _this = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 3) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (
          !values.every((value) => isNaN(value)) &&
          (column.property == "quantity" ||
            column.property == "totalPrice" ||
            column.property == "totalPurePrice" ||
            column.property == "totalPriceAfterTax")
        ) {
          sums[index] = values.reduce((prev, curr) => {
            // curr.replace(/,/g, "")
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          // sums[index] += '';
          // this.$set();
          sums[index] = numFilter(sums[index]);
          if (column.property == "totalPurePrice")
            this.projectForm.totalPurePrice = sums[index];
          else if (column.property == "totalPriceAfterTax")
            this.projectForm.totalPriceAfterTax = sums[index];
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    getGoodSummaries(param) {
      let _this = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 3) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (
          !values.every((value) => isNaN(value)) &&
          (column.property == "quantity" ||
            column.property == "totalPrice" ||
            column.property == "totalPurePrice")
        ) {
          sums[index] = values.reduce((prev, curr) => {
            // curr.replace(/,/g, "")
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          // sums[index] += '';
          // this.$set();
          sums[index] = numFilter(sums[index]);
          if (column.property == "totalPurePrice")
            this.projectForm.totalGoodPurePrice = sums[index];
          else if (column.property == "totalPrice")
            this.projectForm.totalGoodPrice = sums[index];
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.selectEngineerList {
  margin-right: 60px;
  // min-width: 1200px;
  /deep/.el-table__body-wrapper {
    height: auto !important;
  }
  .bottomBtn {
    z-index: 100;
    left: 410px;
    position: fixed;
    bottom: 21px;
  }
}
</style>
